import { Box } from "@chakra-ui/react";
import CDS from "design-system";

export default function DashedButton({ title, onClick }: { title: string; onClick?: () => void; }) {
  return (
    <Box
      as="button"
      border="1px dashed"
      borderColor="fg.subtle"
      borderRadius="full"
      px="8px"
      py="2px"
      w="fit-content"
      onClick={onClick}
    >
      <CDS.Text12 fontStyle="italic" color="fg.subtle">{title}</CDS.Text12>
    </Box>
  );
}
